import React from "react";
import DataComponent from "Core/components/DataComponent";
import {
	E_FAX_LOG_STATUS_CLASS, E_FAX_LOG_STATUS_ICON,
	E_FAX_LOG_STATUSES
} from '../../../pages/apps/default/studies/dialogs/EFaxLogDialog/const';
import SelectInput, {SelectDynamicValueFunction} from 'Core/components/input/SelectInput';
import IconOptionComponent from 'Core/components/input/SelectInput/options/IconOption';
import IconSingleValueComponent from 'Core/components/input/SelectInput/singleValues/IconSingleValue';
import {getString} from 'Core/helpers/data';

class EFaxStatusSelectInput extends DataComponent {
	render() {
		return (
			<SelectInput
				isClearable={true}
				{...this.props}
				options={E_FAX_LOG_STATUSES.map(s => ({value: s, label: this.t(s, 'constants.EFaxLogStatus')}))}
				components={{Option: IconOptionComponent, SingleValue: IconSingleValueComponent}}
				labelProps={{
					symbol: new SelectDynamicValueFunction(o => getString(E_FAX_LOG_STATUS_ICON, o.value)),
					className: new SelectDynamicValueFunction(o => getString(E_FAX_LOG_STATUS_CLASS, o.value)),
				}}
				singleValueProps={{
					symbol: new SelectDynamicValueFunction(o => getString(E_FAX_LOG_STATUS_ICON, o.value)),
					className: new SelectDynamicValueFunction(o => getString(E_FAX_LOG_STATUS_CLASS, o.value)),
				}}
			/>
		);
	}
}

export default EFaxStatusSelectInput;